export class PessoaAluguel {
    nome: string;
    cpfCnpj: string;
    dataNasc: string;
    cep: string;
    email: string;
    fone: string;
    fone1: string;
    cidade: string;
    uf: string;
    logradouro: string;
    complemento: string;
    bairro: string;
    numero: number;
    estadoCivil: number;

    constructor() {
        this.nome = null;
        this.cpfCnpj = null;
        this.dataNasc = null;
        this.cep = null;
        this.email = null;
        this.fone = null;
        this.fone1 = null;
        this.cidade = null;
        this.uf = null;
        this.logradouro = null;
        this.complemento = null;
        this.bairro = null;
        this.numero = null;
        this.estadoCivil = null;
    }
}